<template>
  <div class="pt-1">
    <Card class="card">
      <div class="card-title">{{ $t(title) }} </div>
      <div :class="isNaN(parseInt(value)) ? 'card-nodata' : 'card-number'">
        {{ isNaN(parseInt(value)) ? $t(value) : value }}
        <span v-show="!isNaN(parseInt(value))" class="card-units"> {{ unit }}</span>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String]
    },
    unit: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.card {
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.card-title {
  font-size: 14px;
  padding-top: 4px;
  padding-bottom: 2px;
  text-align: center;
}

.theme--dark .card-title {
  color: #fff;
}

.theme--light .card-title {
  color: #000;
}

.card-number {
  font-size: 24px;
  font-weight: 700;
  color: #668CF6;
  text-align: center;
}

.card-nodata {
  font-size: 24px;
  font-weight: 700;
  color: #ff5252;
  text-align: center;
}

.card-units {
  font-size: 14px;
  font-weight: 700;
  color: #AEAEAE;
}

@media (max-width: 1120px) and (min-width: 910px) {
  .card {
    height: 80px;
  }

  .card-title {
    font-size: 13px;
  }

  .card-number {
    font-size: 20px;
  }

  .card-units {
    font-size: 12px;
  }
}
</style>
